export default __webpack_public_path__ + "static/media/lazarus-logo.7e8e7ef1.svg";